import { useState, useMemo } from "react";
import { MOCK_INVENTORY } from "../config/constants";
import { filterInventory, paginate } from "../utils/helpers";

export const useInventory = () => {
  const [inventory, setInventory] = useState(MOCK_INVENTORY);
  const [filters, setFilters] = useState({
    search: "",
    provider: "all",
    category: "all",
    status: "all",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const filteredInventory = useMemo(() => {
    return filterInventory(inventory, filters);
  }, [inventory, filters]);

  const paginatedInventory = useMemo(() => {
    return paginate(filteredInventory, currentPage, itemsPerPage);
  }, [filteredInventory, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(filteredInventory.length / itemsPerPage);

  const handleFilterChange = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const updateInventoryItem = (updatedItem) => {
    setInventory((prevInventory) =>
      prevInventory.map((item) =>
        item.id === updatedItem.id ? updatedItem : item
      )
    );
  };

  const addInventoryItems = (newItems) => {
    setInventory((prevInventory) => [...prevInventory, ...newItems]);
  };

  return {
    inventory,
    filteredInventory,
    paginatedInventory,
    filters,
    currentPage,
    totalPages,
    itemsPerPage,
    handleFilterChange,
    handlePageChange,
    updateInventoryItem,
    addInventoryItems,
  };
};
